import {UserRoleCreateComponent} from "./user-role-create.component";

export default UserRoleCreateComponent;
